import { constantRoutes } from '@/router'
import { generatorDynamicRouter } from '@/router/generator-routers'

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes) // 全部的路由
  }
}

const actions = {
  clearRoutes ({ commit, state, dispatch }) {
    commit('SET_ROUTES', [])
  },
  generateRoutes ({ commit }) {
    return new Promise(resolve => {
    // 获取该角色权限下的路由
      const routers = generatorDynamicRouter()
      if (routers) {
        commit('SET_ROUTES', routers)
        resolve(routers)
      } else {
        commit('SET_ROUTES', [])
        resolve([])
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
